<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 12 12"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#4A6592">
        <g>
          <g>
            <g>
              <path
                d="M11.131 3.162c.187-.203.503-.217.707-.03.18.165.212.434.085.634l-.054.072-5.5 6c-.177.192-.465.213-.667.064l-.07-.064-5.5-6c-.187-.204-.173-.52.03-.707.181-.165.451-.173.64-.03l.067.061L6 8.76l5.131-5.598z"
                transform="translate(-451 -2290) translate(255 1916) translate(0 362) translate(196 12)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'ChevronDownIcon',
  props: {
    height: VueTypes.string.def('12'),
    width: VueTypes.string.def('12'),
    color: VueTypes.string.def('#6783B2'),
  },
};
</script>

<style lang="scss"></style>
